import React from 'react';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthShell } from '../../components/AuthShell/AuthShell';
import { Button } from '../../components/ui/Button/Button';

export const PasswordChangedPage: FC = () => {
    const navigate = useNavigate();

    return (
        <AuthShell
            title="Пароль изменён"
            lead="Войдите в систему с новым паролем."
        >
            <Button variant="primary" onClick={() => navigate('/login', { replace: true })}>
                Перейти ко входу
            </Button>
        </AuthShell>
    );
};